import Grid from '@mui/material/Grid';
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import { DigitalizacionesList } from "../components/Digitalizaciones/DigitalizacionesList";
import { EstadisticasDigitalizaciones } from "../components/Digitalizaciones/EstadisticasDigitalizaciones";
import { PageHeaderCard } from 'src/general_components/PageHeaderCard';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

export function OcrAdmin() {
  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title="Digitalización con OCR" icon={<AutoFixHighIcon />} />
      <Grid sx={{ px: 1, mb: 2 }}>
        <EstadisticasDigitalizaciones />
      </Grid>
      <CajasProvider ocrMode={true}>
        <Grid>
          <DigitalizacionesList />
        </Grid>
      </CajasProvider>
    </Grid>
  );
}
